import { render, staticRenderFns } from "./NfseLocalEvento.vue?vue&type=template&id=f275b206&scoped=true&"
import script from "./NfseLocalEvento.vue?vue&type=script&lang=js&"
export * from "./NfseLocalEvento.vue?vue&type=script&lang=js&"
import style0 from "./NfseLocalEvento.vue?vue&type=style&index=0&id=f275b206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f275b206",
  null
  
)

export default component.exports